export const hash = 'f491926b-90ae-11ec-920b-16b38c2c4059';

// export const gateKey = '';
export const gateKey = '';
export const recaptchaKey = '6Ld9r7cZAAAAABw5wijiLD5PhlWqLivIN9NqFKi_';
export const apiUrl = `https://api-global-v2.encontrodigital.com.br/${hash}`;
export const apiSocket = 'https://socket-2023.encontrodigital.com.br';
// export const apiSocket = 'http://localhost:8001';

//export const apiUrl = `http://localhost:8000/${hash}`;
export const websitePath = 'https://avc.encontrodigital.com.br';
export const urlWebsite = 'https://avc.encontrodigital.com.br';
export const supportNumber = `555195181533`;
export const home = 'Home';
export const haveTranslate = false;
// export const urlWebsite = 'http://localhost:3000';
export const eventName = 'PORTAL DO AVC';
export const logo = '/apoio/logobranca.png';
export const background = '/assets/evento/Fundo.jpeg';
export const authTitle = 'PORTAL DO AVC';
export const dadosOrganizacao = '';
export const social = {
  whatsapp: '',
  instagram: 'https://www.instagram.com/redebrasilavc',
  facebook: 'https://www.facebook.com/CampanhaAVC',
  linkedin: '',
  youtube: '',
  twitter: '',
  website: 'https://www.globalstrokealliance.com/pt/home/'
};


export const defaultTheme = {
  defaultBackground: 'rgb(0,50,150)',
  defaultColor: '#fff',
  logo: {
    minWidth: '450px',
  },
  menu: {
    background: 'none',
    backgroundSticky: 'none',
    backgroundMobile: 'rgb(0,50,150)',
    color: '#fff',
    shadow: '0',
    logoColor: 'none',
  },
};

export const getToken = (): string | null => {
  const token = localStorage.getItem(`@${authTitle}:token`);
  return token;
};
